module.exports = __webpack_public_path__ + "static/img/1.6f4575c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/zh/1.png
// module id = va1H
// module chunks = 0